export const COMPANY_NAME = "Shoptosa";
export const COMPANY_ADDRESS = "3200 Parkwood Road, Plano, TX 75093";
export const COMPANY_ADDRESS_LINES = ["3200 Parkwood Road", "Plano, TX 75093", "United States"];
export const SUPPORT_EMAIL = "alerts@shoptosa.com";
export const HELLO_EMAIL = SUPPORT_EMAIL;
export const PRIVACY_EMAIL = SUPPORT_EMAIL;
export const SITE_URL = "https://shoptosa.com";
